import { render, staticRenderFns } from "./EditStudySetWrapper.vue?vue&type=template&id=6238186b&scoped=true&"
import script from "./EditStudySetWrapper.vue?vue&type=script&lang=js&"
export * from "./EditStudySetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditStudySetWrapper.vue?vue&type=style&index=0&id=6238186b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238186b",
  null
  
)

export default component.exports